import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api_urls } from "../../../utils/api-urls/index.js";
import { EditSvg, DeleteSvg } from "../../../assets/svg/index.js";
import logo from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeepSearchSpace } from "../../../utils/common-function/index.js";
import MainDatatable from "../../../components/datatable/MainDatatable.jsx";
import DatatableHeading from "../../../components/datatable/DatatableHeading.jsx";
import * as AstromallActions from '../../../redux/actions/astromallAction';

const Category = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { astromallCategoryData: categoryData } = useSelector(state => state.astromallReducer);
    const [searchText, setSearchText] = useState('');
    const filteredData = DeepSearchSpace(categoryData, searchText);

    //* DataTable Columns
    const columns = [
        { name: 'S.No.', selector: row => categoryData.indexOf(row) + 1 },
        { name: 'Title', selector: row => <div style={{ textTransform: 'capitalize' }}>{row?.categoryName}</div> },
        { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/astro-mall/category/add-category', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                <div onClick={() => dispatch(AstromallActions.deleteAstromallCategory({ categoryId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div >,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Getting Category
        dispatch(AstromallActions.getAstromallCategory())
    }, []);

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <DatatableHeading title={'Mall Category'} data={categoryData} url={'/astro-mall/category/add-category'} />

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "20px", alignItems: 'center', marginBottom: "20px", backgroundColor: "#fff" }}>
                    <input type='search' value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder='Search your data...' style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '250px', fontSize: '15px', outline: 'none', }} />
                </div>

                <MainDatatable columns={columns} data={filteredData} />
            </div>
        </ >
    );
}

export default Category;